import React from 'react'
import PropTypes from 'prop-types'
import {
  Chip,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import { CommonDialog } from '@/components/common'

export const DriveDonorsRecipientsDialog = ({
  open,
  onClose,
  recipients = [],
  skipped = [],
}) => {
  const hasRecipients = recipients.length > 0 || skipped.length > 0

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title='Selected Recipients'
      actions={
        <Typography variant='body2' sx={{ px: 2, pb: 1 }}>
          {recipients.length} will receive, {skipped.length} will be skipped
        </Typography>
      }
    >
      <DialogContent dividers>
        {!hasRecipients ? (
          <Typography variant='body2' color='text.secondary'>
            No selected donors found.
          </Typography>
        ) : (
          <List dense disablePadding>
            {recipients.map(recipient => (
              <ListItem key={`receive-${recipient.donor_id}`} divider>
                <ListItemText
                  primary={recipient.donor_name}
                  secondary={recipient.email}
                />
                <Chip size='small' color='success' label='Will receive' />
              </ListItem>
            ))}
            {skipped.map(recipient => (
              <ListItem key={`skip-${recipient.donor_id}`} divider>
                <ListItemText
                  primary={recipient.donor_name}
                  secondary={
                    recipient.reason || 'No valid email address on file.'
                  }
                />
                <Chip size='small' label='Will be skipped' />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </CommonDialog>
  )
}

DriveDonorsRecipientsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  recipients: PropTypes.array,
  skipped: PropTypes.array,
}
